export default {
  THREAD_LABEL_BOX_PADDING: {
    top: 9,
    right: 12,
    bottom: 9,
    left: 6
  },
  THREAD_LABEL_BOX_ICON_SIZE: 22,
  THREAD_LABEL_BOX_ICON_MARGIN_RIGHT: 10,
  THREAD_LABEL_LINE_HEIGHT: 22,
  THREAD_AVATAR_SIZE: 22,
  THREAD_AVATAR_FONT_SIZE: 11,

  THREAD_LABEL_LEFT: 10,
  THREAD_LABEL_WIDTH: 240,
  THREAD_SPLIT_WIDTH: 250,

  NODE_JUNCTION_SIZE: 30,
  NODE_NORMAL_SIZE: 24,
  NODE_JUNCTION_BORDER_WIDTH: 4,

  LINE_WIDTH: 4,

  HEADER_HEIGHT: 36
};
